import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from './auth.service';
import { Sucursales, Usuario } from './interfaces/interfaces';
@Component({
    selector: 'app-authentication',
    templateUrl: './authentication.component.html',
    styleUrls: ['./authentication.component.scss'],
    standalone: false
})
export class AuthenticationComponent implements OnInit {

  loginForm:  FormGroup = this.formBuilder.group({
    usuario:    ['', [ Validators.required, Validators.required ]],
    password:   ['', [ Validators.required, Validators.required ]],
    sucursales: ['', [ Validators.required, Validators.required]]
  });

  public spinnerBoolean: boolean =  false;
  public _arraySucursales: Sucursales[] = [];
  private _usuario!: Usuario;
  public ipv4 :string = "";
  public showPassword: boolean = false;
  constructor(
    private formBuilder: FormBuilder,
    public router: Router,
    public route: ActivatedRoute,
    private toastr: ToastrService,
    private authService: AuthService,
  ) { 

    this._usuario = authService.loginUsuario;
    this.authService.validarToken().subscribe((ok) => {
      if (ok === true) {
        this.router.navigate(['sistema/inicio']);
      }
    });

   
    
  }

  ngOnInit(): void {
  
    this.getSucursales();
     this.authService.getIpAdress().subscribe((resp) => {

      var content = JSON.parse(JSON.stringify(resp));

      console.log(content);
   
      this.ipv4 = content.IPv4;

    });
  }

  get form(){
    return this.loginForm.controls;
  }

  togglePasswordVisibility(): void {
    this.showPassword = !this.showPassword;
  }

  /* -------------------------------------------------------------------------- */
  /*                               INGRESAR LOGIN                               */
  /* -------------------------------------------------------------------------- */
  Submit(){

      const {usuario, password, sucursales} = this.loginForm.value;
      if(usuario == ""){

          this.toastr.warning('El email es un campo obligatorio', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });

          return;
      }

      if(password == "" ){

          this.toastr.warning('El password es un campo obligatorio', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
      }

      this.spinnerBoolean =  true;

      this.authService.login(usuario, password).subscribe(async resp=>{

       
          if(resp["rows"].length>0){
            if (Number(resp["rows"][0].estado) === 0) {
              this.spinnerBoolean = false;
              this.toastr.error('El usuario con el que ingresó se encuentra desactivado.', 'Atención', {
                timeOut: 3000,
                closeButton: true,
                progressBar: true
              });
              return;
            }

            const omitirValidacionIp = String(resp["rows"][0].omitir_validacion_ip ?? '0') === '1';

            // Validar dirección IP solo cuando el usuario no está configurado para omitirla.
            if (!omitirValidacionIp) {
              let validarIp: any;
              try {
                validarIp = await this.validarDireccionIp(
                  sucursales,
                  resp["rows"][0].llave_secreta_usuario
                );
              } catch (error) {
                this.spinnerBoolean = false;
                this.toastr.error('No se pudo validar la dirección IP. Intente nuevamente.', 'Atención', {
                  timeOut: 3000,
                  closeButton: true,
                  progressBar: true
                });
                return;
              }
              if(!validarIp.operacion){
                 this.spinnerBoolean =  false;
                 this.toastr.error(validarIp.ip + ' Error al ingresar, este dispositivo no tiene autorización.', 'Atención', {
                   timeOut: 3000,
                   closeButton: true,
                   progressBar: true
                 });
                 return;
              }
            }
          

                const direccionUsuario = resp["rows"][0].DIR_SURC;
                const token = resp["rows"][0].llave_secreta_usuario;
                let codigoSucursal = sucursales;
                const sucursalSeleccionada = this._arraySucursales.find(
                  item => String(item.COD_SURC) === String(codigoSucursal)
                );
                const direccionSucursal = sucursalSeleccionada?.DIR_SURC || direccionUsuario;

                localStorage.setItem('token', token);

                this.authService
                  .updateSucursal(
                    resp["rows"][0].id,
                    codigoSucursal,
                    resp["rows"][0].llave_secreta_usuario
                  )
                  .subscribe({
                    next: () => {
                      this.spinnerBoolean = false;
                      this.toastr.success('Acceso con éxito', 'Atención', {
                        timeOut: 3000,
                        closeButton: true,
                        progressBar: true
                      });

                      this.router.navigateByUrl('/sistema/inicio');
                    },
                    error: () => {
                      localStorage.removeItem('token');
                      this.spinnerBoolean = false;
                      this.toastr.error('No se pudo fijar la sucursal seleccionada. Intente ingresar nuevamente.', 'Atención', {
                        timeOut: 3000,
                        closeButton: true,
                        progressBar: true
                      });
                    }
                  });
            return;
        
          }else{

            this.toastr.error('Los datos proporcionados son incorrectos', 'Atención', {
              timeOut: 3000,
              closeButton: true,
              progressBar: true
            });

            this.spinnerBoolean =  false;

        

          }

      }, (error) => {
        this.spinnerBoolean = false;
        const retryAfterSeconds =
          Number(error?.error?.errors?.retryAfterSeconds || 0);
        const message = error?.status === 429
          ? `Demasiados intentos fallidos. Intente nuevamente en ${this.formatRetryAfter(retryAfterSeconds)}.`
          : error?.error?.message ||
            'No se pudo iniciar sesión. Verifique sus credenciales.';

        this.toastr.error(message, 'Atención', {
          timeOut: error?.status === 429 ? 6000 : 3000,
          closeButton: true,
          progressBar: true
        });
      });
  }

  private formatRetryAfter(seconds: number): string {
    if (!Number.isFinite(seconds) || seconds <= 0) {
      return 'unos minutos';
    }

    const minutes = Math.ceil(seconds / 60);
    return minutes === 1 ? '1 minuto' : `${minutes} minutos`;
  }


  validarDireccionIp(sucursal,token){
    return new Promise((resolve, reject)=>{
      this.authService.validarIpUsuario(sucursal,token).subscribe({
        next: (resp) => resolve(resp),
        error: (error) => reject(error)
      });
    });
  }

  /* -------------------------------------------------------------------------- */
  /*                              CARGAR SUCURSALES                             */
  /* -------------------------------------------------------------------------- */
  getSucursales(){
    
    const item = null;
    const valor = null;
    const tipo = "login";
    const token = "no";

    this._arraySucursales = [];
    this.authService.cargarSucursales(tipo,item, valor, token).subscribe((resp) => {
      resp["rows"].forEach((currentValue, index) => {
   
        var sucursales: Sucursales = {
          COD_SURC: currentValue.COD_SURC,
          DIR_SURC: currentValue.DIR_SURC,
        };
        this._arraySucursales.push(sucursales);
      });
    });
     

  }

}
